// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
        // setError(err.response?.data?.message || 'Error de conexión');
        console.log("Detalle del error:", err.response); // Esto te dirá si es un error de CORS o de Servidor
        setError(err.response?.status === 503 ? 'Servidor Protegido (503)' : 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#1a1a2e 0%,#16213e 50%,#0f3460 100%)' },
    card: { background: '#fff', borderRadius: 12, padding: 40, width: 360, boxShadow: '0 20px 60px rgba(0,0,0,.4)' },
    logo: { textAlign: 'center', marginBottom: 28 },
    input: { width: '100%', padding: '10px 14px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', outline: 'none' },
    btn: { width: '100%', padding: '12px', background: '#d4940a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 },
    err: { background: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 6, padding: '8px 12px', color: '#a8071a', fontSize: 13, marginTop: 8 },
    label: { display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 600, color: '#333' },
    field: { marginBottom: 16 },
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>
          <div style={{ fontSize: 32 }}>⛏</div>
          <h2 style={{ margin: '8px 0 4px', color: '#1a1a2e' }}>MACDESA</h2>
          <p style={{ margin: 0, color: '#888', fontSize: 13 }}>Sistema de Gestión de Viajes</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Usuario</label>
            <input style={s.input} value={form.username} onChange={e => setForm({...form, username: e.target.value})} required autoFocus />
          </div>
          <div style={s.field}>
            <label style={s.label}>Contraseña</label>
            <input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          {error && <div style={s.err}>{error}</div>}
          <button style={{...s.btn, opacity: loading ? .7 : 1}} disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: '#bbb' }}>
          Minera Aurífera Cuatro de Enero S.A. © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
